export const BOOK_LIST_REQUEST = 'BOOK_LIST_REQUEST'
export const BOOK_LIST_SUCCESS = 'BOOK_LIST_SUCCESS'
export const BOOK_LIST_FAIL = 'BOOK_LIST_FAIL'
export const BOOK_LIST_DELETE_ONE = 'BOOK_LIST_DELETE_ONE'

export const BOOK_DELETE_REQUEST = 'BOOK_DELETE_REQUEST'
export const BOOK_DELETE_SUCCESS = 'BOOK_DELETE_SUCCESS'
export const BOOK_DELETE_FAIL = 'BOOK_DELETE_FAIL'

export const BOOK_CREATE_REQUEST = 'BOOK_CREATE_REQUEST'
export const BOOK_CREATE_SUCCESS = 'BOOK_CREATE_SUCCESS'
export const BOOK_CREATE_FAIL = 'BOOK_CREATE_FAIL'
export const BOOK_CREATE_RESET = 'BOOK_CREATE_RESET'

export const BOOK_UPDATE_REQUEST = 'BOOK_UPDATE_REQUEST'
export const BOOK_UPDATE_SUCCESS = 'BOOK_UPDATE_SUCCESS'
export const BOOK_UPDATE_FAIL = 'BOOK_UPDATE_FAIL'
export const BOOK_UPDATE_RESET = 'BOOK_UPDATE_RESET'

export const BOOK_DETAILS_REQUEST = 'BOOK_DETAILS_REQUEST'
export const BOOK_DETAILS_SUCCESS = 'BOOK_DETAILS_SUCCESS'
export const BOOK_DETAILS_FAIL = 'BOOK_DETAILS_FAIL'
export const BOOK_DETAILS_RESET = 'BOOK_DETAILS_RESET'

export const BOOK_REVIEWS_REQUEST = 'BOOK_REVIEWS_REQUEST'
export const BOOK_REVIEWS_SUCCESS = 'BOOK_REVIEWS_SUCCESS'
export const BOOK_REVIEWS_FAIL = 'BOOK_REVIEWS_FAIL'
export const BOOK_REVIEWS_RESET = 'BOOK_REVIEWS_RESET'

export const BOOK_RECENT_REVIEWED_REQUEST = 'BOOK_RECENT_REVIEWED_REQUEST'
export const BOOK_RECENT_REVIEWED_SUCCESS = 'BOOK_RECENT_REVIEWED_SUCCESS'
export const BOOK_RECENT_REVIEWED_FAIL = 'BOOK_RECENT_REVIEWED_FAIL'
export const BOOK_RECENT_REVIEWED_RESET = 'BOOK_RECENT_REVIEWED_RESET'

export const BOOK_USER_RECENT_REVIEWED_REQUEST = 'BOOK_USER_RECENT_REVIEWED_REQUEST'
export const BOOK_USER_RECENT_REVIEWED_SUCCESS = 'BOOK_USER_RECENT_REVIEWED_SUCCESS'
export const BOOK_USER_RECENT_REVIEWED_FAIL = 'BOOK_USER_RECENT_REVIEWED_FAIL'
export const BOOK_USER_RECENT_REVIEWED_RESET = 'BOOK_USER_RECENT_REVIEWED_RESET'

export const BOOK_CREATE_REVIEW_REQUEST = 'BOOK_CREATE_REVIEW_REQUEST'
export const BOOK_CREATE_REVIEW_SUCCESS = 'BOOK_CREATE_REVIEW_SUCCESS'
export const BOOK_CREATE_REVIEW_FAIL = 'BOOK_CREATE_REVIEW_FAIL'
export const BOOK_CREATE_REVIEW_RESET = 'BOOK_CREATE_REVIEW_RESET'

export const GOOGLE_BOOK_SAVE_REQUEST = 'GOOGLE_BOOK_SAVE_REQUEST'
export const GOOGLE_BOOK_SAVE_SUCCESS = 'GOOGLE_BOOK_SAVE_SUCCESS'
export const GOOGLE_BOOK_SAVE_FAIL = 'GOOGLE_BOOK_SAVE_FAIL'
export const GOOGLE_BOOK_SAVE_RESET = 'GOOGLE_BOOK_SAVE_RESET'

export const BOOK_TOP_RATED_REQUEST = 'BOOK_TOP_RATED_REQUEST'
export const BOOK_TOP_RATED_SUCCESS = 'BOOK_TOP_RATED_SUCCESS'
export const BOOK_TOP_RATED_FAIL = 'BOOK_TOP_RATED_FAIL'

export const BOOK_DELETE_REVIEW_REQUEST = 'BOOK_DELETE_REVIEW_REQUEST'
export const BOOK_DELETE_REVIEW_SUCCESS = 'BOOK_DELETE_REVIEW_SUCCESS'
export const BOOK_DELETE_REVIEW_FAIL = 'BOOK_DELETE_REVIEW_FAIL'
